import { useRef, useContext } from "react";
import { GlobalModalContext } from "src/utils/GlobalModal/GlobalModalContext";
import __ from "src/utils/Translations";
import { IAbsenceGroup } from "src/Pages/Company/Absences/AbsenceGroups/AbsenceGroups.models";
import { IAbsenceType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import { useSaveAbsenceGroupsOrderConfiguration } from "src/Pages/Company/Absences/api/absenceGroups.queries";
import AbsenceGroupSorting, {
  IAbsenceGroupSortingRef,
} from "./AbsenceGroupSorting";

interface IUseAbsenceGroupSortingModalParams {
  companyId: string;
  absenceGroups: IAbsenceGroup[] | undefined;
  absenceTypes: IAbsenceType[] | undefined;
}

const useAbsenceGroupSortingModal = ({
  companyId,
  absenceGroups,
  absenceTypes,
}: IUseAbsenceGroupSortingModalParams) => {
  const { setModal, resetModal } = useContext(GlobalModalContext);
  const sortingRef = useRef<IAbsenceGroupSortingRef>(null);
  const { mutate: saveOrder, isPending: isSavingOrder } =
    useSaveAbsenceGroupsOrderConfiguration(companyId, resetModal);

  const openSortingModal = () => {
    setModal({
      open: true,
      title: __("Zmiana kolejności grup i szablonów wniosków"),
      customElements: (
        <AbsenceGroupSorting
          ref={sortingRef}
          companyId={companyId}
          absenceGroups={absenceGroups}
          absenceTypes={absenceTypes}
          onSave={saveOrder}
        />
      ),
      actions: [
        {
          label: __("Anuluj"),
          variant: "outlined",
          callbackFn: resetModal,
        },
        {
          label: __("Zapisz zmiany"),
          variant: "contained",
          loading: isSavingOrder,
          callbackFn: () => sortingRef.current?.save(),
        },
      ],
    });
  };

  return { openSortingModal };
};

export default useAbsenceGroupSortingModal;
